module.exports = __webpack_public_path__ + "static/media/img_preview.b8b002fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_preview.png
// module id = 940
// module chunks = 0